<template lang="html">
  <Layout currentMenu="Account" subMenu="Analytics">
    <div class="analytics">
      <Template />
    </div>
  </Layout>
</template>

<script>
import EventBus from 'src/components/EventBus.js'
import Template from './Template.vue'
import Layout from 'src/components/dashboard/shares/Layout.vue'

export default {
  components: { Template, Layout },
  methods: {
    assignUserData(user) {
      this.userId = user.id
      this.loading = false
      this.$analytic.loadgooglecharts(this.userId)
    },
  },
  data() {
    return {
      loading: false,
      userId: null,
    }
  },
  created() {
    EventBus.$on('user-fetched', this.assignUserData)
  },
  beforeDestroy() {
    EventBus.$off('user-fetched', this.assignUserData)
  },
  mounted() {
    this.loading = true
    this.$user.fetchMe()
  },
}
</script>

<style lang="scss">
@import './css/anyliticsstyle.scss';
@import './css/dropdown.scss';
</style>
